import { PropTypes } from 'prop-types';
import React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;

const StrikeThroughText = ({strikeThrough, value }) => {
  return <Text style={{ textDecoration: strikeThrough? 'line-through red' : "none" }}>{value}</Text>;
};

StrikeThroughText.propTypes = {
  strikeThrough: PropTypes.bool,
  value: PropTypes.any,
};

export default StrikeThroughText;
